import styled from "styled-components"

export const Container = styled.div`
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  flex-direction: column;
  width: 95%;
  max-width: 1000px;
`
